import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
@Injectable({
  providedIn: 'root',
})
export class CambiarContrasenaService {
  url: string = environment.apiLocalUrl;

  constructor(private http: HttpClient) {}

  getCambioContrasena(body:any){
    return this.http.post(this.url + 'comun/servicios/cambioContrasenia/', body).pipe(catchError(HandleHttpError));
  }
}